export default __webpack_public_path__ + "static/media/background-4.eeb5d1c2.png";